import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import * as ApiConfig from '../core/apiconfig';
import * as Model from './index.model';
import * as SharedModel from '../core/index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';
import { Guid } from 'guid-typescript';
import { API_URL, API_PDFService } from '../core/apiconfig';
import { cspformsmodel } from './cspformsmodel.model';
import { BehaviorSubject } from 'rxjs/Rx';
import { CSRequest } from './CSRequest.model';
import { debug } from 'console';

@Injectable()
export class cspFormsService {
    private apiUrl: string;
    public profileInfo: SharedModel.ProfileInfo;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    private sharedData = new BehaviorSubject<string>(''); // Default value is empty string
    currentData = this.sharedData.asObservable();
    constructor(private _http: Http) {
        this.apiUrl = ApiConfig.API_URL;
      
    }
    getcspformsRefno(PDFFormID: any) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(
                this.apiUrl + ApiConfig.API_PDFService + "/GetCSFormsRefNo/" + PDFFormID, this.Http_Header_Request_Options
               // this.apiUrl + "/" + ApiConfig.API_PDFService + "/GetCSFormsRefNo/" + PDFFormID, this.Http_Header_Request_Options
                )
            .toPromise()
            .then((response) => {
                return response.json() as Model.cspformsmodel;
            })
            .catch(this.handleError);
    }
    GetCSRequestNo(RequestId: any) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(
                this.apiUrl + ApiConfig.API_PDFService + "/GetCSRequestNo/" + RequestId, this.Http_Header_Request_Options
               // this.apiUrl + "/" + ApiConfig.API_PDFService + "/GetCSFormsRefNo/" + PDFFormID, this.Http_Header_Request_Options
                )
            .toPromise()
            .then((response) => {
                return response.json() ;
            })
            .catch(this.handleError);
    }

    // Handle Error
    CreateCSPForms(pdfdata: cspformsmodel) {
        let objectData = pdfdata;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(
            API_URL + API_PDFService + '/CreateCSPForm', objectData, this.Http_Header_Request_Options
           // API_URL + "/" + API_PDFService + '/CreateCSPForm', objectData, this.Http_Header_Request_Options
            )
            .map((res: Response) => res);
    }
    CreateOpReqest(Requestdata: CSRequest) {
        let objectData = Requestdata;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(
            API_URL + API_PDFService + '/CSRequest', objectData, this.Http_Header_Request_Options
           // API_URL + "/" + API_PDFService + '/CreateCSPForm', objectData, this.Http_Header_Request_Options
            )
            .map((res: Response) => res);
    }
    InsertPicture(pdfdata: any) {
        debugger;
        let objectData = pdfdata;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(
            API_URL + API_PDFService + '/CSPFormPicture', objectData, this.Http_Header_Request_Options
            // API_URL + "/" + API_PDFService + '/CreateCSPForm', objectData, this.Http_Header_Request_Options
        )
            .map((res: Response) => res);
    }
    updateData(data: string) {
        this.sharedData.next(data); // Emit new data value
      }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/services/cspforms.service.ts